import { render, staticRenderFns } from "./CardProjectSummary.vue?vue&type=template&id=ba19c79e&scoped=true&"
import script from "./CardProjectSummary.vue?vue&type=script&lang=js&"
export * from "./CardProjectSummary.vue?vue&type=script&lang=js&"
import style0 from "./CardProjectSummary.vue?vue&type=style&index=0&id=ba19c79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba19c79e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VChip,VSpacer})
